<template>
<div class="box5-page">
  <div class="fcp-title">认证考试内容及占比</div>
  <div class="fcp-text">透明且清晰的考试内容分配及占比，让你知己知彼百战不殆</div>
  <ul class="list-cont">
    <li v-for="(item, index) in list" @click="openMask(index)">
      <p>{{ item.title }}</p>
      <div class="info">
        <span>{{ item.info1 }}</span>
        <span>{{ item.info2 }}</span>
      </div>
      <div class="bottom">
        查看详情
      </div>
    </li>
  </ul>
  <div class="check-info-mask" v-if="flag">
    <div class="check-info-cont">
      <i class="mask-close" @click="closeMask"></i>
      <h2 class="cont-stit">{{ currMaskInfo.title }}</h2>
      <ul class="cont-list">
        <li v-for="(item, index) in currMaskInfo.info" :key="index">
          <h4 v-show="item.stit">{{ item.stit }}</h4>
          <p v-for="(v1, i1) in item.text" :key="i1">{{ v1 }}</p>
        </li>
      </ul>
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: '',
  data() {
    return {
      flag: false,
      list:[
        {
          title: 'FineReport模块',
          info1: '占比25%',
          info2: '共 6 题'
        },
        {
          title: 'SQL编程语言模块',
          info1: '占比25%',
          info2: '共 6 题'
        },
        {
          title: 'Kettle数据处理模块',
          info1: '占比25%',
          info2: '共 7 题'
        },
        {
          title: '服务器部署模块',
          info1: '占比25%',
          info2: '共 6 题'
        }
      ],
      list2: [
        {
          title: 'FineReport模块',
          info: [
            {
              stit: '基础查询',
              text: [
                '· 父子格、参数使用与条件属性运用',
                '· 超级链接、基础图表与函数运用',
                '· 多个功能组合应用实现模拟业务场景'
              ]
            },
            {
              stit: '填报应用',
              text: [
                '· 父子格、参数使用与条件属性运用',
                '· 超级链接、基础图表与函数运用',
                '· 数据填报、JS与权限运用',
                '· 多个功能组合应用实现模拟业务场景'
              ]
            },
            {
              stit: '报表复现',
              text: [
                '· 大屏驾驶舱与移动端报表制作实操',
                '· 图表使用、大屏布局、配色与开发',
                '· 移动端看板布局、配色与开发'
              ]
            }
          ]
        },
        {
          title: 'SQL编程语言模块',
          info: [
            {
              stit: '数据库',
              text: [
                '· 数据库对象的基本概念与作用'
              ]
            },
            {
              stit: '简单查询',
              text: [
                '· 使用 SQL 语句创建、选择、修改、删除、查看数据库对象的操作方法及应用'
              ]
            },
            {
              stit: '复杂查询',
              text: [
                '· 多表连接查询',
                '· 流程控制函数、聚合函数、窗口函数',
                '· 嵌套与子查询'
              ]
            },
          ]
        },
        {
          title: 'Kettle数据处理模块',
          info: [
            {
              stit: '',
              text: [
                '· Kettle输入组件、输出组件、转换组件、应用组件实操',
                '· 利用Kettle实现数据抽取、数据转化、数据同步功能'
              ]
            },
          ]
        },
        {
          title: '服务器部署模块',
          info: [
            {
              stit: '',
              text: [
                '· Windows与Linux环境下工程部署',
                '· FineReport数据决策系统管理和使用'
              ]
            },
          ]
        }
      ],
      currMaskInfo: {}
    }
  },
  methods:{
    openMask(index){
      this.currMaskInfo = this.list2[index]
      this.flag = true
      document.getElementsByTagName('html')[0].style.overflowY = 'hidden'
    },
    closeMask(){
      this.flag = false
      document.getElementsByTagName('html')[0].style.overflowY = 'visible'
    }
  }
}
</script>

<style lang="scss" scoped>
.box5-page{
  padding: 80px 0 62px;
  background-image: url(../../../assets/coursePage/fcp/box5/box5-bg.png);
  background-size: cover;
  .list-cont{
    margin-top: 48px;
    padding: 0 32px;
    display: flex;
    justify-content: space-between;
    flex-wrap:wrap;
    li{
      width: 330px;
      height: 220px;
      border-radius: 20px;
      border: 2px solid rgba(220, 240, 255, 1);
      box-sizing: border-box;
      padding-top: 32px;
      position: relative;
      background: #FFFFFF;
      margin-bottom: 26px;
      overflow: hidden;
      background-image: url(../../../assets/coursePage/fcp/box5/icon-01.png);
      background-size: 72px 72px;
      background-repeat: no-repeat;
      background-position: center 16px;
      box-shadow: 0px 8px 32px 0px rgba(132,158,244,0.2);
      p{
        font-size: 28px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #1D2129;
        line-height: 44px;
        text-align: center;
      }
      .info{
        width: 204px;
        margin: 8px auto 0;
        display: flex;
        justify-content: space-between;
        span{
          font-size: 24px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #86909C;
          line-height: 36px;
        }
      }
      .bottom{
        width: 100%;
        height: 68px;
        background: #F7FBFF;
        left: 0;
        bottom: 0;
        position: absolute;
        text-align: center;
        line-height: 68px;
        font-size: 24px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #0066FF;
      }
    }
  }
}

.check-info-mask{
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,.6);
  z-index: 120;
  .check-info-cont{
    width: 100%;
    box-sizing: border-box;
    padding: 48px;
    background-color: #fff;
    box-shadow: 0px 4px 40px 0px rgba(0,0,0,0.08);
    border-radius: 24px 24px 0px 0px;
    position: absolute;
    bottom: 0;
    left: 0;
    .mask-close{
      position: absolute;
      top: 48px;
      right: 48px;
      width: 32px;
      height: 32px;
      background-image: url(../../../assets/coursePage/fcp/box5/icon-close.png);
      background-size: 100% 100%;
    }
    .cont-stit{
      font-size: 36px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #1D2129;
      line-height: 52px;
      text-shadow: 0px 4px 40px rgba(0,0,0,0.08);
    }
    .cont-list{
      li{
        margin-top: 32px;
        h4{
          font-size: 28px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #4E5969;
          line-height: 44px;
          text-shadow: 0px 4px 40px rgba(0,0,0,0.08);
          margin-bottom: 16px;
        }
        p{
          font-size: 26px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #4E5969;
          line-height: 44px;
          text-shadow: 0px 4px 40px rgba(0,0,0,0.08);
        }
      }
    }
  }
}
</style>